<dx-data-grid
  #gridArticoli
  [dataSource]="dataSource"
  [showBorders]="true"
  [focusedRowEnabled]="false"
  [focusedRowIndex]="0"
  [allowColumnResizing]="true"
  [columnAutoWidth]="true"
  [columnResizingMode]="columnResizingMode"
  [showColumnLines]="true"
  [showRowLines]="true"
  [rowAlternationEnabled]="false"
  [allowColumnReordering]="true"
  [wordWrapEnabled]="false"
  (onRowDblClick)="goToDetail($event.data.id)">

  <dxo-paging [pageSize]="10"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [showInfo]="true" [allowedPageSizes]="[10, 20, 50, 100]"></dxo-pager>
  <dxo-filter-row [visible]="false"></dxo-filter-row>
  <dxo-header-filter [visible]="false"  [allowSearch]="true"></dxo-header-filter>
  <dxo-export [enabled]="false"></dxo-export>
  <dxo-column-chooser [enabled]="false"></dxo-column-chooser>

  <dxo-editing
    mode="row"
    [allowAdding]="false"
    [allowUpdating]="false"
    [allowDeleting] ="false"
    [useIcons]="true">
    <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
  </dxo-editing>

  <dxi-column
    dataField="idTipo"
    caption="Tipologia"
    width="180"
    [calculateSortValue]="sortByLookup"
    [visible]="false">
    <dxo-lookup [dataSource]="listTipiArticoli" valueExpr="id" displayExpr="descrizione"></dxo-lookup>
  </dxi-column>

  <dxi-column
    dataField="idCategoria"
    caption="Categoria"
    width="180"
    [visible]="false">

  </dxi-column>

  <dxi-column
    dataField="codice"
    caption="Codice"
    width="130"
    [sortIndex]="1"
    sortOrder="asc">
  </dxi-column>

  <dxi-column
    dataField="descrizione"
    caption="Descrizione">
  </dxi-column>

  <dxi-column
    dataField="giacenza"
    caption="Giacenza"
    dataType="number"
    width="90">
  </dxi-column>

  <dxi-column
    caption="STATO"
    [allowSorting]="false"
    [allowFiltering]="false"
    cellTemplate="statoGiacenza">
  </dxi-column>

  <div *dxTemplate="let d of 'statoGiacenza'">
    @if (isEsaurito(d.data.giacenza)) {
      <span class="badge text-white bg-danger" style="font-size:12px">Esaurito</span>
    }

    @if (!isEsaurito(d.data.giacenza) && isSottoscorta(d.data.giacenza,d.data.scortaMinima)) {
      <span class="badge text-dark bg-warning" style="font-size:12px">Sottoscorta</span>
    }
  </div>

</dx-data-grid>
